// extracted by mini-css-extract-plugin
export default {"container":"HomeAppRow_container__iCnT6","image":"HomeAppRow_image__MQDxx","description":"HomeAppRow_description__nEhLL"};